export default function () {
  if (document.fullscreenEnabled) {
    const isFullscreen = !!document.fullscreenElement
    if (isFullscreen) {
      document.exitFullscreen()
    } else {
      document.documentElement.requestFullscreen()
    }
  } else {
    console.log('Fullscreen not enabled on this browser')
  }
}
